export default function BrandBelief() {
  return (
    <section className="py-20 lg:py-28 bg-gradient-to-b from-white to-[#F8FCFD]">
      <div className="max-w-4xl mx-auto px-6 lg:px-12">
        <div className="space-y-6 text-center">
          <p className="text-lg lg:text-xl text-gray-700 leading-relaxed">
            They do more than treat animals. They guide pet owners, build trust, improve outcomes, and bring compassion to moments that matter.
          </p>
          <p className="text-lg lg:text-xl text-gray-700 leading-relaxed">
            Their expertise creates real impact for pets, families, and communities.
          </p>
          <p className="text-xl lg:text-2xl font-semibold text-[#0F1F3D] leading-relaxed pt-2">
            Vetuvia believes veterinarians with passion can change the world for the better — and that belief shapes everything we build.
          </p>
        </div>
      </div>
    </section>
  );
}